import React, { useEffect, useMemo, useState } from "react";
import { isNil } from "ramda";

import { logout, logoutRedirect } from "../../auth";

export const LogoutTokenContext = React.createContext<{ logoutToken: Maybe<string> }>({ logoutToken: null });

export const LogoutHandler: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [storedLogoutToken, setStoredLogoutToken] = useState<Maybe<string>>(null);
  useEffect(() => {
    const logoutToken = localStorage.getItem("logoutToken") || null;
    setStoredLogoutToken(logoutToken);
  }, []);

  useEffect(() => {
    const storageListener = async (e: StorageEvent) => {
      if (e.key === "logoutToken" && e.oldValue) {
        await logout(storedLogoutToken);
        logoutRedirect();
      }
      if (isNil(e.key) && isNil(e.oldValue) && isNil(e.newValue)) {
        await logout(storedLogoutToken);
        logoutRedirect();
      }
    };
    window.addEventListener("storage", storageListener);
    return () => {
      window.removeEventListener("storage", storageListener);
    };
  });

  const logoutTokenContextValue = useMemo(() => ({ logoutToken: storedLogoutToken }), [storedLogoutToken]);

  return <LogoutTokenContext.Provider value={logoutTokenContextValue}>{children}</LogoutTokenContext.Provider>;
};
